<template>
  <div class="input__wrapper align-center justify-center">
    <v-combobox
      v-model="currentSearchValue"
      v-click-outside="false"
      solo
      hide-no-data
      label=""
      color="white"
      :loading="isLoading"
      :search-input.sync="search"
      :placeholder="placeholder"
      @input="handleValue"
    >
      <template #prepend-inner>
        <img
          width="24"
          height="24"
          src="../../../src/assets/search-icon.svg"
          alt=""
        />
      </template>
      <template #append>
        <v-btn
          v-if="search && !isDisplayChip"
          x-small
          icon
          depressed
          class="mt-1 mr-2"
          @click="clearSearchText"
        >
          <img src="../../../src/assets/close.svg" alt="" />
        </v-btn>
        <v-btn
          v-if="!isDisplayChip"
          class="searchBtn"
          @click="handleSearchClick"
          small
          >Search</v-btn
        >
        <v-chip
          v-if="isDisplayChip"
          class="ma-2 chip-close"
          @click:close="onCloseChip"
          text-color="#fff"
        >
          <template name="default">
            <img
              src="../../../src/assets/chip-close.svg"
              alt=""
              class="close-btn"
              @click="onCloseChip"
            />
          </template>
          <v-icon
            v-if="isLoading"
            color="primary"
            class="donwload-icon spinner-icon"
          >
            mdi-autorenew
          </v-icon>
          {{ !isLoading ? totalResult : '' }} Results
        </v-chip>
      </template>
    </v-combobox>
  </div>
</template>

<script type="ts">
export default {
  data: () => ({
    currentSearchValue: '', // value on enter
    search: null, // value on keypress
    isDisplayChip: false,
  }),
  props: {
    searchText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search our Glossary',
    },
    totalResult: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    if (this.searchText) {
      this.handleSearchText();
    }
  },
  watch: {
    search() {
      if (!this.search) {
        this.isDisplayChip = false;
      }
    },
    searchText() {
      if (!this.searchText) {
        this.clearSearchText();
      } else {
        this.handleSearchText();
      }
    }
  },
  methods: {
    handleSearchText() {
      this.search = this.searchText;
      this.currentSearchValue = this.searchText;
      this.isDisplayChip = true;
    },
    handleValue(text) {
      this.isDisplayChip = true;
      this.currentSearchValue = text;
      this.$emit('search', this.currentSearchValue);
    },
    clearSearchText() {
      this.search = null;
      this.currentSearchValue = null;
      this.isDisplayChip = false;
    },
    onCloseChip() {
      this.clearSearchText();
      this.$emit('search', this.search);
    },
    handleSearchClick() {
      this.isDisplayChip = true;
      this.currentSearchValue = this.search;
      this.$emit('search', this.currentSearchValue);
    },
  },
};
</script>

<style scoped>
.input__wrapper >>> .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #ccd3de;
  border-radius: 0 !important;
}
.input__wrapper >>> .v-input__icon--append {
  display: none;
}
.input__wrapper >>> .searchBtn {
  background-color: var(--v-primary-base);
  color: white;
  font-weight: 800;
  font-size: 12px;
  padding: 0.5rem 1.2rem !important;
  box-shadow: 1px solid var(--v-primary-base);
  cursor: pointer;
}
.input__wrapper >>> .searchBtn:hover {
  box-shadow: 0px 4px 10px rgba(70, 156, 82, 0.24);
}
.chip-close {
  background: #234025 !important;
  width: 110px;
  padding-left: 20px;
  font-weight: bold;
  font-size: 12px;
}
.chip-close .close-btn {
  position: absolute;
  right: 10px;
  cursor: pointer;
}
.spinner {
  border: 0 !important;
  pointer-events: none;
  margin-left: -2em;
}
.spinner-icon {
  animation: spin-animation 1s infinite;
  animation-timing-function: linear;
  font-weight: 400 !important;
  font-size: 14px;
  font-weight: 200;
  background-color: transparent;
  margin-right: 4px;
}
@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
